import React, { useEffect, useState } from 'react';
import { UsersIcon } from 'lucide-react';
const START_SPOTS = 23;
export function ScarcityBar() {
  const [spots, setSpots] = useState(START_SPOTS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSpots(prev => prev <= 7 ? START_SPOTS : prev - 1);
    }, 24000);
    return () => window.clearInterval(timer);
  }, []);
  const total = 200;
  const taken = total - spots;
  const percent = Math.round(taken / total * 100);
  return <div className="w-full max-w-xl mx-auto rounded-2xl border border-brandred/20 bg-brandred-tint px-4 py-4" data-id="element-43" data-mp="2g5l8qh6phfmv">
      <div className="flex items-center justify-between gap-3 text-xs sm:text-sm font-semibold text-navy" data-id="element-44" data-mp="226ll9cuxj6sa">
        <span className="flex items-center gap-1.5" data-id="element-45" data-mp="274dbm2fxekud">
          <UsersIcon className="w-4 h-4 text-brandred" aria-hidden="true" data-id="element-46" data-mp="276zrcpcz06no" />
          Cupos al precio promocional
        </span>
        <span className="text-brandred font-extrabold" data-id="element-47" data-mp="5ebl0751533o">Quedan {spots}</span>
      </div>
      <div className="mt-3 h-3 w-full rounded-full bg-white overflow-hidden border border-brandred/20" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label="Cupos ocupados" data-id="element-48" data-mp="33mv4md77gz2k">
        <div className="h-full rounded-full bg-brandred transition-all duration-700" style={{
        width: `${percent}%`
      }} data-id="element-49" data-mp="3dbwq2iwis8nx" />
      </div>
      <p className="mt-2 text-[11px] sm:text-xs text-navy/70" data-id="element-50" data-mp="2kn8zc7t04r2z">
        {percent}% de los cupos de lanzamiento ya fueron tomados. Al agotarse, el
        precio vuelve a $247 USD.
      </p>
    </div>;
}